export function scrollToNote(id: string) {
  // Force a 0 timeout cause we're referencing react elements from vanilla JS
  setTimeout(() => {
    const note = document.getElementById(`note-${id}`)

    if (note) {
      note.scrollIntoView({ behavior: "smooth", block: "center" })
      note.classList.toggle("bg-warning/30")
      setTimeout(() => {
        note.classList.toggle("bg-warning/30")
      }, 1500)
    }
  }, 0)
}
